import PropTypes from 'prop-types';

import Spacer from 'shared_DEPRECATED/components/Spacer';

const CardBody = ({ children }) => <Spacer size="sm zr zr">{children}</Spacer>;

CardBody.propTypes = {
  /**
   * The content of the component.
   * @type {React.ReactNode}
   * @required
   * @name children
   * @memberof CardBody
   * @example <CardBody>Content</CardBody>
   */
  children: PropTypes.node.isRequired,
};

export default CardBody;
